import React from 'react'
import { createRoot } from 'react-dom/client'
import styles from './Modal.module.less'

export default class Modal extends React.Component {
  onOk = () => {
    if (this.props.onOk) {
      this.props.onOk()
    }

    this.props.onCancel()
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { title, content, DOM, okText, cancelText, closable = true, onOk } = this.props

    return (
      <div className={styles.modal_mask}>
        <div className={styles.modal}>
          <div className={styles.text}>{title || __['app.points.common.tip']}</div>
          {DOM ? DOM : <div className={styles.text_sm}>{content}</div>}

          {closable ? (
            <div className={styles.btn_list}>
              <div className={styles.btn} onClick={this.onOk}>
                {okText || __['app.points.common.ok']}
              </div>
              {onOk ? (
                <div className={styles.btn_cancel} onClick={this.onCancel}>
                  {cancelText || __['app.points.common.cancel']}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

export function tooltip(props) {
  const el = document.createElement('div')
  document.body.appendChild(el)

  const root = createRoot(el)

  const onCancel = () => {
    root.unmount()
    document.body.removeChild(el)
  }

  root.render(<Modal {...props} onCancel={onCancel} />)
}
